import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const SharedListItemStyles = css`
  display: block;
  padding: ${layout.spacing.xSmall};
  cursor: pointer;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

const ListItem = styled(Clickable)`
  ${SharedListItemStyles};
`;

export default ListItem;
